import { Component, OnInit, ElementRef, ViewChild, Renderer2, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';  // Check if platform is browser
import { Router } from '@angular/router';
import { Constants } from '../../common/constants';
import * as AOS from 'aos';
import { AfterViewInit,ChangeDetectionStrategy,ChangeDetectorRef,Input,QueryList,ViewChildren } from '@angular/core';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { SeoService } from 'src/app/common/seo.service';
declare var $ : any;
export interface TimelineElement {
  caption: string;
  date: Date;
  title: string;
  selected?: boolean;
  content: string;
}
@Component({
  selector: 'app-journey',
  templateUrl: './journey.component.html',
  styleUrls: ['./journey.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('contentState', [
      state('active', style({
        position: 'relative', 'z-index': 2, opacity: 1,
      })),
      transition('right => active', [
        style({
          transform: 'translateX(100%)'
        }),
        animate('400ms ease-in-out', keyframes([
          style({ opacity: 0, transform: 'translateX(100%)', offset: 0 }),
          style({ opacity: 1, transform: 'translateX(0%)', offset: 1.0 })
        ]))
      ]),
      transition('active => right', [
        style({
          transform: 'translateX(-100%)'
        }),
        animate('400ms ease-in-out', keyframes([
          style({ opacity: 1, transform: 'translateX(0%)', offset: 0 }),
          style({ opacity: 0, transform: 'translateX(100%)', offset: 1.0 })
        ]))
      ]),
      transition('active => left', [
        style({
          transform: 'translateX(-100%)'
        }),
        animate('400ms ease-in-out', keyframes([
          style({ opacity: 1, transform: 'translateX(0%)', offset: 0 }),
          style({ opacity: 0, transform: 'translateX(-100%)', offset: 1.0 })
        ]))
      ]),
      transition('left => active', [
        style({
          transform: 'translateX(100%)'
        }),
        animate('400ms ease-in-out', keyframes([
          style({ opacity: 0, transform: 'translateX(-100%)', offset: 0 }),
          style({ opacity: 1, transform: 'translateX(0%)', offset: 1.0 })
        ]))
      ]),
    ])
  ]
})
export class JourneyComponent  implements OnInit{
  isBrowser:boolean=false;
  baseUrl = Constants.baseUrl;

  constructor(
    private titleService: Title,
    private metaService: Meta,private router: Router,@Inject(PLATFORM_ID) private platformId: any,private seoService:SeoService,
    private _cdr: ChangeDetectorRef,  private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
"@context": "https://schema.org/",
"@type": "Person",
"name": "Prasad Maganti",
"url": "https://mitresource.com/journey/",
"image": "https://mitresource.com/assets/images/journey/prasad_ceosir.png",
"sameAs": "https://www.linkedin.com/in/prasadmaganti/",
"jobTitle": "Founder",
"worksFor": {
  "@type": "Organization",
  "name": "Maganti IT Resources, LLC"
}  
}`;
   
    this._renderer2.appendChild(this._document.head, script);

    if (this.isBrowser) {
      AOS.init({ disable: 'mobile', duration: 2000, delay: 500 });
    }
    this.seoService.createLinkForCanonicalURL();
    this.setTitleAndMetaTags();  }


    ngAfterViewInit(): void {
      if (isPlatformBrowser(this.platformId)) {
      this.initializeJourneySlickCarousel();
      }
    }


    // onEmpIdClick(empId: string) {
    //   console.log('Employee ID clicked:', empId);
    //   // Navigate to the profile page with the employee ID
    //   this.router.navigate(['/profile', empId]);
    // }

    private setTitleAndMetaTags(): void {
      this.seoService.createLinkForCanonicalURL();
      this.titleService.setTitle('Our Journey | Milestones of Success at Maganti IT');
  
      this.metaService.addTags([
        { name: 'description', content: 'We’re a team of forward thinkers, innovators, pioneers and executors who believe that collective knowledge can transform all our futures with a greater purpose.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'Our Journey | Milestones of Success at Maganti IT' },
        { property: 'og:url', content: 'https://mitresource.com/journey/' },
        { property: 'og:image', content: 'https://mitresource.com/assets/images/techtraining_images/trainingimage1.png' },
        { property: 'og:description', content: 'We’re a team of forward thinkers, innovators, pioneers and executors who believe that collective knowledge can transform all our futures with a greater purpose.' },
      ]);
    }
  carouselItems = [
    {
      name: 'Prasad Maganti',
      title: 'Founder',
      description: 'Founder and Entrepreneur with over 35 years of experience in the IT industry, Prasad has accomplished leader with domestic and international experience in operations, P&L oversight, product development, and marketing involving start-ups, mid-sized businesses, and growth organizations.',
      link: 'https://www.linkedin.com/in/prasadmaganti/',
      imageClass: 'prasadsir-image',
       empId:'001'
    },
    {
      name: 'Sushma Maganti',
      title: 'Co-Founder',
      description: 'Over 24 years experience as a demonstrated leader, and in-depth technology expertise - Sushma strives to sustain a culture of diversity and inclusion. Has a proven track record to deliver intelligent, innovative, cost-effective & secure infrastructure applications to global businesses.',
      link: 'https://www.linkedin.com/in/sushmamaganti/',
      imageClass: 'sushmamaam-image',
       empId:'002'
    },
    {
      name: 'Gita Poudel',
      title: 'Director-Human Capital/Compliance',
      description: 'Dedicated, self-motivated, and experienced Human Resource professional with an extensive background in employment and immigration laws. With over 17 years of experience, Gita proactively develops HR strategies to meet short and long-term business needs and manages strategies from conception to implementation by identifying areas of growth.',
      link: 'https://www.linkedin.com/in/gita-p-7558aa64/',
      imageClass: 'hrmadam-image',
       empId:'4001'
    },
    {
      name: 'Venkata Sainath K',
      title: 'Director & Business Initiatives',
      description: 'A demonstrated leader with years of experience in the IT sector, possessing valuable insights, keen analysis, and a team approach to implementing best practices to achieve business excellence. Adept in modules involving design and implementation, developing applications through lifecycles.',
      link: 'https://www.linkedin.com/in/sainath-kadiyala-a3544aaa/',
      imageClass: 'venkatasainathsir-image',
       empId:'037'
    },
    {
      name: 'Prabhakar Maganti',
      title: 'Managing Director',
      description: 'Over 36 years of experience in solving complex business issues from strategy to execution, Prabhakar is focused on shaping the business and developing industry tailored solutions that support clients through the entire lifecycle of the Workday Implementation.',
      link: '',
      imageClass: 'prabhakarsir',
       empId:'4002'
    },
    {
      name: 'Sudha Chilukuri',
      title: 'Marketing Manager',
      description: 'Has years of experience in the Education, Professional Training sectors with outstanding leadership and mentoring skills. Sudha Rani has been involved in administering, planning, and building careers for a large body of students and resolving issues affecting recruiting procedures.',
      link: 'https://www.linkedin.com/in/sudha-rani-chilukuri-b718773b/',
      imageClass: 'sudhamaam',
      empId:'4003'
    },
    {
      name: 'Rajkumar N',
      title: 'Director of Technology Services',
      description: 'Having more than 13 years of experience in developing web applications by using web technologies. Extensive experience in developing web applications using frameworks SPRING, STRUTS, HIBERNATE, .NET.',
      link: 'https://www.linkedin.com/in/raj-kumar-50677b1a4/',
      imageClass: 'rajkumarsir-image',
       empId:'043'
    },
    {
      name: 'Venkata Rajyam V',
      title: 'Director Resource Management/Operations',
      description: 'With over 13 years of proven experience in developing and delivering web applications, Rajyam is expertise in JAVA, .NET technologies, and various third-party integrations.',
      link: 'https://www.linkedin.com/in/rajyam-v-79b957100/',
      imageClass: 'rajyammadam-image',
       empId:'059'
    },
    {
      name: 'Sai Srikanth',
      title: 'Global Product Officer',
      description: 'Experienced Data Platform Modernization specialist. His unique insight into data processing, cloud & extensive management experience have contributed to the Maganti vision and goals. Proud recipient of the Honorary Golden Key International Award, a Gold medalist with a Master\'s degree in Data Science and Artificial Intelligence from Deakin University, Australia.',
      link: 'https://www.linkedin.com/in/sai-srikanth-bezawada',
      imageClass: 'SaiSrikanth-image',
       empId:'4004'
    },
    {
      name: 'Mohammad Yaseen',
      title: 'Senior Business Development Manager',
      description: 'With over 10+ years of experience in sales and recruiting, I provide innovative engineering solutions to advanced technology companies that advance corporate goals and increase profitability.',
      link: 'https://www.linkedin.com/in/mohammad-yaseen-67aa5859/',
      imageClass: 'yaseen-image',
       empId:'049'
    }
  ];
  onEmpIdClick(item: any) {
    if (item.empId) {
      this.router.navigate(['/profile', item.empId, item.link]);
      
    } else if (item.link) {
      window.open(item.link, '_blank');
    } else {
    }
  }
  initializeJourneySlickCarousel() {
    $('.leaderJourney').slick({infinite: true,
      arrows: false,
      dots: true,
      autoplay: false,
      speed: 800,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]})}




  content = {};

  timeline: TimelineElement[] = [
    { caption: '2023', date: new Date(2014, 1, 10), selected: true, title: 'Our New Branch Location', content: 'Launched Maganti IT in Australia, Canada and UK.'},
    { caption: '2022', date: new Date(2014, 1, 20), title: 'Our New Office Location', content:'Relocated to a new Office space in Connecticut.' },
    { caption: '2019', date: new Date(2014, 1, 30), title: 'Additional Offshore location', content:'Established two additional offshore locations in India.' },
    { caption: '2018', date: new Date(2014, 2, 10), title: 'Certification', content: 'Gained ISO 9001:2015 Certification.' },
    { caption: '2017', date: new Date(2014, 2, 15), title: 'Achievement', content: 'Approved by Better Business Bureau.' },
    { caption: '2016', date: new Date(2014, 2, 25), title: 'Affiliation', content: 'Affiliated membership with Minority Supplier Development Council.' },
    { caption: '2014', date: new Date(2014, 3, 1), title: 'New location and software development', content: 'Opened second IT company in Naugatauk, CT, USA. Built own all-in-one management software called CuroRC.' },
    { caption: '2013', date: new Date(2014, 3, 10), title: 'Revenue', content: 'Over 200% revenue growth from private custom platform custom platform application.'},
    { caption: '2012', date: new Date(2014, 3, 20), title: 'Offshore IT company', content: 'Established offshore company in India.' },
    { caption: '2011', date: new Date(2014, 4, 1), title: 'New Location', content: 'Groundbreaking newly acquired location in Naugatauk, Connecticut.'},
    { caption: '2008', date: new Date(2014, 4, 10), title: 'Growth', content: 'Growth of company to 15 employees' },
    { caption: '2004', date: new Date(2014, 4, 20), title: 'Foundation', content: 'Started with 2 dedicated employees.' },

  ];


}
